module.exports = __webpack_public_path__ + "img/1m.260d62e8.png";